import React from 'react';
import './TransactionIDDisplay.css';

function TransactionIDDisplay({ verificationId, onReset, createdAt }) {
  const handleCopy = () => {
    navigator.clipboard.writeText(verificationId);
    // Optional: Show toast notification
    const toast = document.createElement('div');
    toast.className = 'copy-toast';
    toast.textContent = '✓ Copied to clipboard';
    document.body.appendChild(toast);
    setTimeout(() => toast.remove(), 2000);
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  return (
    <div className="transaction-id-display">
      <div className="transaction-card">
        <div className="success-checkmark">✓</div>
        
        <h2>Verification Submitted</h2>
        <p className="subtitle">Your verification has been submitted successfully</p>

        <div className="transaction-info">
          <div className="info-group">
            <label>Transaction ID</label>
            <div className="transaction-id-box">
              <code className="transaction-id-value">{verificationId}</code>
              <button
                onClick={handleCopy}
                className="copy-button"
                title="Copy to clipboard"
              >
                📋 Copy
              </button>
            </div>
          </div>

          {createdAt && (
            <div className="info-group">
              <label>Submitted At</label>
              <div className="submitted-time">
                <p>{formatDate(createdAt)}</p>
              </div>
            </div>
          )}
        </div>

        <button onClick={onReset} className="new-verification-button">
          ← Start New Verification
        </button>
      </div>
    </div>
  );
}

export default TransactionIDDisplay;
